module.exports = __webpack_public_path__ + "img/product-card-02.c6dd6dd.webp";